/**
 * @module contentsquare-drawer-pageviews
 * @description Sends an artificial pageview to Contentsquare when the cart drawer
 * opens, and re-sends the real page URL on close so later activity isn't credited to the drawer.
 * Listens on the generic drawer:opened/closed events every BaseDrawer dispatches —
 * add other drawer names to TRACKED_DRAWERS to extend coverage later.
 * @see https://docs.contentsquare.com/en/web/artificial-pageviews/#custom-html
 */
const TRACKED_DRAWERS = ['cart-drawer'];

const trackVirtualPageview = (path) => {
  window._uxa = window._uxa || [];
  window._uxa.push(['trackPageview', path]);
};

document.addEventListener('drawer:opened', (e) => {
  if (TRACKED_DRAWERS.includes(e.detail.name)) trackVirtualPageview(`/virtual/${e.detail.name}/open`);
});
document.addEventListener('drawer:closed', (e) => {
  // Hand the current page back to the real URL; a virtual close path would stay
  // "current" in CS and soak up every later click until the next navigation.
  if (TRACKED_DRAWERS.includes(e.detail.name)) trackVirtualPageview(`${location.pathname}${location.search}`);
});
